import axios from "axios";

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");
const isLocalBrowser = ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
const configuredUrlIsLocal = /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(:\d+)?$/i.test(configuredBackendUrl);
const backendUrl = configuredBackendUrl && (!configuredUrlIsLocal || isLocalBrowser)
  ? configuredBackendUrl
  : isLocalBrowser ? "http://localhost:8000" : window.location.origin;

export const mediaUrl = (value) => {
  if (typeof value !== "string" || !value.trim()) return "";
  const raw = value.trim();
  try {
    const parsed = new URL(raw, backendUrl || window.location.origin);
    if (parsed.pathname === "/uploads" || parsed.pathname.startsWith("/uploads/")) {
      parsed.pathname = `/api${parsed.pathname}`;
    }
    if (!isLocalBrowser && ["localhost", "127.0.0.1", "::1"].includes(parsed.hostname)) {
      const publicBackend = new URL(backendUrl || window.location.origin);
      parsed.protocol = publicBackend.protocol;
      parsed.host = publicBackend.host;
    }
    return /^https?:\/\//i.test(raw)
      ? parsed.toString()
      : `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return raw;
  }
};

export const api = axios.create({
  baseURL: `${backendUrl}/api`,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_4d6f09d5-8ccf-485c-aa22-c210231afd27/artifacts/df640db076725731_Vearnlogo.webp";

export const fmt = (n) => "₹" + Math.round(Number(n || 0)).toLocaleString("en-IN");

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const response = e?.response;
  const d = response?.data?.detail || response?.data?.message || response?.data?.error;
  if (!d) {
    if (!response && e?.request) return "Unable to reach the Vearn server. Check your connection and try again.";
    if (response?.status >= 500) return `The Vearn server could not complete this request (HTTP ${response.status}). Please try again shortly.`;
    return fallback;
  }
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
};

export const ORDER_STYLES = {
  CREATED: "bg-amber-100 text-amber-800",
  PAID: "bg-emerald-100 text-emerald-800",
  PROCESSING: "bg-blue-100 text-blue-800",
  SHIPPED: "bg-indigo-100 text-indigo-800",
  DELIVERED: "bg-emerald-100 text-emerald-800",
  CANCELLED: "bg-rose-100 text-rose-800",
  CREATE_FAILED: "bg-rose-100 text-rose-800",
  PAYMENT_FAILED: "bg-rose-100 text-rose-800",
};
